import { render, staticRenderFns } from "./b-professional-selected.vue?vue&type=template&id=015160ad&"
import script from "./b-professional-selected.vue?vue&type=script&lang=js&"
export * from "./b-professional-selected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports